import React, {FC, PropsWithChildren} from 'react';

import {BannerAnimation} from './bannerAnimation';
import {BannersListContext} from './bannersContext';

/*
 * Props.
 */

interface BannersHostProps {
  width: number;
}

/*
 * Style.
 */

/*
 * Component.
 */

export const BannersHost: FC<PropsWithChildren<BannersHostProps>> = (props) => {
  const {width, children} = props;

  return (
    <BannersListContext.Consumer>
      {(banners) => (
        <>
          <BannerAnimation banners={banners} width={width} />
          {children}
        </>
      )}
    </BannersListContext.Consumer>
  );
};
